import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Form, Input, Select, message, Upload, Checkbox, Switch, Radio, Drawer, Space, Spin, Tabs, Tag } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import ImgCrop from 'antd-img-crop';
import { Link } from "react-router-dom";
import { Scrollbars } from 'react-custom-scrollbars';
import FeatherIcon from 'feather-icons-react';
import { useSelector } from 'react-redux';
import InitialData from '../Pages/InitialData.json'
import { getProdCategory, FecthTableNames, IndustryData } from '../../../Api/Services/CommonApiService';
import { getTargetRoles, getTargetDepartments, getCompetitors } from '../../../Api/Services/CompanyApiService';
import { AccountsByAccountType } from '../../../Api/Services/AccountApiService';
import {
    getCompanyProject,
    createDealProduct,
    getProductDetails,
    deleteDealProduct,
    updateDealProduct,
} from '../../../Api/Services/Productapiservice';
import { getQueryFieldsByType } from '../../../Api/Services/ViewApiService';
import { AddUser } from '../style';
import { BasicFormWrapper, VerticalFormStyleWrap } from '../../styled';
import { RelatedDocUpload } from '../Pages/GlobalComponents/RelatedDocUpload'
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import { convertCurrency, ExchangeCurrency, DateforQueryBuilder } from '../Filters/FilterConditions';
import { getBaseURL } from '../../../Api/ApiConfig';
import ConfirmationPopup from '../Popup/ConfirmationPopup'
import AllCancelPopup from '../Popup/AllCancelPopup'
import DeleteConnectionPopup from '../Popup/DeleteConnectionPopup';
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import { CancelIcon, EditIcon, AiIcon } from '../../../components/Icons/Icons';
import QueryBuilderFunction from '../QueryBuilderComp/QueryBuilderFile'
import { validateShortText, validateDescriptionField } from '../../../components/utilities/utilities';

const { Option } = Select;

function AddNew({ drawerOpen, OpenProduct, drawerFrom, drawerType, drawerId, GetAll, successMessage, typePage }) {
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const [form] = Form.useForm();
    const localData = useSelector((state) => state.localRedux);
    const defaultCurrency = localData.currency
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const [FILEList, setFileList] = useState([]);
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const [doubleClick1, setDoubleClick1] = useState(false)
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [account, setAccount] = useState([])
    const [productImg, setProductImg] = useState()
    const [deleteOption, setDeleteOpen] = useState(false);
    const [checked, setChecked] = useState(false);
    const [allProject, setAllProject] = useState();
    const [displayData, setDisplayData] = useState()
    const [edit, setEdit] = useState(false)
    const [edit1, setEdit1] = useState(false)
    const [margin, setMargin] = useState()
    const [action, setAction] = useState("Globally")
    const [queryField, setQueryField] = useState([])
    const [leadInitial, setLeadInitial] = useState()
    const [uiLoad, setUiLoad] = useState(false)
    const [accountbyType, setAccountbyType] = useState([])
    const [industryData, setIndustryData] = useState([])
    const [method, setMethod] = useState()
    const [productCost, setProductCost] = useState()
    const [viewPopupType, setViewPopupType] = useState()
    const [calculation, setCalculation] = useState()
    const [confirmPopup, setConfirmPopup] = useState(false)
    const [deleteId, setDeleteId] = useState()
    const [productCat, setProductCat] = useState([])
    const [display, setDisplay] = useState(false)
    const [errorData, setErrorData] = useState([])
    const [entityTableMap, setEntityTableMap] = useState([])
    const [currencySettings, setCurrencySetting] = useState()
    const [productActive, setProductActive] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [activeKey, setActiveKey] = useState('1')
    const ConvertRate = currencySettings?.exchangeRate;
    const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
    const [group, setGroup] = useState();
    const [uiReady, setUiReady] = useState(false)

    function arrayToString(val) {
        if (Array.isArray(val) && val.length > 0) {
            return val.join(",");
        }
        return null;  // 👈 return null if empty or not an array
    }
    function splitToArray(value) {
        if (!value) return [];
        return value.split(",").map(v => v.trim());
    }
    async function getAllTableName() {
        try {
            const data = await FecthTableNames()
            setEntityTableMap(data)
        } catch (error) {
            message.error(error);
        }
    }
    async function IndustryDataApi() {
        try {
            const data = await IndustryData()
            const options = data.map((option, i) => (
                <Option value={option.industryName} key={i}>
                    {option.industryName}
                </Option>));
            setIndustryData(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function getTargetRolesData() {
        setDisplay(true)
        let hideMessage;
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await getTargetRoles(companyProfile?.companyId, drawerId, "Product", {})
            let cleaned = typeof response === "string" ? response.trim() : JSON.stringify(response);
            cleaned = cleaned.replace(/^\s*```json\s*/i, "").replace(/\s*```$/i, "").trim();
            const parsed = typeof response === "string" ? JSON.parse(cleaned) : response;
            let responseArr = [];
            if (Array.isArray(parsed)) {
                responseArr = parsed;
            } else if (parsed.relevantJobRoles && Array.isArray(parsed.relevantJobRoles)) {
                responseArr = parsed.relevantJobRoles;
            } else {
                const firstArray = Object.values(parsed).find(v => Array.isArray(v));
                if (firstArray) responseArr = firstArray;
            }
            const oldValues = form.getFieldValue("buyerPersons") || [];
            const merged = [...oldValues, ...responseArr];
            const uniqueDepartments = [...new Set(merged)];
            form.setFieldsValue({ buyerPersons: uniqueDepartments });
            hideMessage();
            setDisplay(false)
        } catch (error) {
            setDisplay(false)
            if (hideMessage) hideMessage();
            message.error(error)
        }
    }
    async function getTargetDepartmentsData() {
        setDisplay(true)
        let hideMessage;
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await getTargetDepartments(companyProfile?.companyId, drawerId, "Product", {})
            let cleaned = typeof response === "string" ? response : JSON.stringify(response);
            cleaned = cleaned.replace(/^\s*```json\s*/i, "").replace(/\s*```$/i, "").trim();
            const responseArr = JSON.parse(cleaned);
            const oldValues = form.getFieldValue("targetDepartments") || [];
            const merged = [...oldValues, ...responseArr];
            const uniqueDepartments = [...new Set(merged)];
            form.setFieldsValue({ targetDepartments: uniqueDepartments });
            hideMessage();
            setDisplay(false)
        } catch (error) {
            setDisplay(false)
            if (hideMessage) hideMessage();
            message.error(error)
        }
    }
    async function getCompetitorsData() {
        setDisplay(true)
        let hideMessage;
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await getCompetitors(companyProfile?.companyId, drawerId, "Product", {})
            let cleaned = typeof response === "string" ? response : JSON.stringify(response);
            cleaned = cleaned.replace(/^\s*```json\s*/i, "").replace(/\s*```$/i, "").trim();
            const responseArr = JSON.parse(cleaned);
            const oldValues = form.getFieldValue("directCompetitors") || [];
            const merged = [...oldValues, ...responseArr];
            const uniqueDepartments = [...new Set(merged)];
            form.setFieldsValue({ directCompetitors: uniqueDepartments });
            hideMessage();
            setDisplay(false)
        } catch (error) {
            setDisplay(false)
            if (hideMessage) hideMessage(); // hide loading if shown
            message.error(error)
        }
    }
    function convertDateFromProfile(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(profile?.timeZone);
        const toTimezone = extractTimezoneName(company?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const currentTimeInProfile = moment.tz(fromTimezone).format("HH:mm");
        const dateWithTime = moment.tz(
            `${dateTime} ${currentTimeInProfile}`,
            "YYYY-MM-DD HH:mm",
            fromTimezone
        );
        const converted = dateWithTime.clone().tz(toTimezone);
        const formattedDate = converted.format("YYYY-MM-DD");
        return formattedDate
    }
    function convertDateFromCompany(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const currentTimeInProfile = moment.tz(fromTimezone).format("HH:mm");
        const dateWithTime = moment.tz(
            `${dateTime} ${currentTimeInProfile}`,
            "YYYY-MM-DD HH:mm",
            fromTimezone
        );
        const converted = dateWithTime.clone().tz(toTimezone);
        const formattedDate = converted.format("YYYY-MM-DD");
        return formattedDate
    }
    const noValueConditions = new Set([
        "IS NOT EMPTY", "IS NOT NULL", "IS EMPTY", "IS NULL",
        "today", "tomorrow", "yesterday",
        "this_week", "next_week", "last_week",
        "this_month", "next_month", "last_month",
        "this_financial_year", "next_financial_year", "last_financial_year",
        "this_quarter", "next_quarter", "last_quarter"
    ]);
    // const isValidEmail = (email) => {
    //     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //     return emailPattern.test(email);
    // };
    // const isValidPhoneNumber = (phoneNumber) => {
    //     const phonePattern = /^[0-9+-]+$/;
    //     return phonePattern.test(phoneNumber);
    // };
    // const isValidWebsite = (website) => {
    //     const websiteRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    //     return websiteRegex.test(website);
    // };
    // const fieldsToValidate = ['primary_email', 'secondary_email', 'email', 'mobile', 'assistant_contact_number', 'phone', 'website'];
    // const validateQuery = (query) => {
    //     if (!fieldsToValidate.includes(query.field)) {
    //         return true;
    //     }
    //     if (noValueConditions.has(query.operator)) {
    //         return true;
    //     }
    //     switch (query.field) {
    //         case 'primary_email':
    //         case 'secondary_email':
    //         case 'email':
    //             if (!isValidEmail(query.value)) {
    //                 message.error(`Please enter a valid email address.`);
    //                 return false;
    //             }
    //             break;
    //         case 'mobile':
    //         case 'assistant_contact_number':
    //         case 'phone':
    //             if (!isValidPhoneNumber(query.value)) {
    //                 message.error(`Invalid number.`);
    //                 return false;
    //             }
    //             break;
    //         case 'website':
    //             if (!isValidWebsite(query.value)) {
    //                 message.error(`Please enter a valid website url.`);
    //                 return false;
    //             }
    //             break;
    //         default:
    //             return false;
    //     }
    //     return true;
    // };
    // const validateQueryData = (queryItems) => {
    //     const validateItems = (items) => {
    //         for (let i = 0; i < items.length; i += 1) {
    //             const item = items[i];
    //             if (item.type === "condition") {
    //                 const isValid = validateQuery(item);
    //                 if (!isValid) return false;
    //             } else if (item.type === "group" && Array.isArray(item.items)) {
    //                 const isGroupValid = validateItems(item.items);
    //                 if (!isGroupValid) return false;
    //             }
    //         }
    //         return true;
    //     };
    //     return validateItems(queryItems);
    // };
    function RequiredValidity(queryItems) {
        const validateItems = (items) => {
            for (let i = 0; i < items.length; i += 1) {
                const item = items[i];
                if (item.type === "condition") {
                    if (!item.field || !item.operator) {
                        return { isValid: false, message: "Incomplete query" };
                    }
                    const conditionValue = item.value;
                    const isEmptyValue =
                        conditionValue === undefined ||
                        conditionValue === null ||
                        conditionValue === "" ||
                        (Array.isArray(conditionValue) && conditionValue.length === 0);
                    if (!noValueConditions.has(item.operator) && isEmptyValue) {
                        return { isValid: false, message: "Incomplete query" };
                    }
                } else if (item.type === "group" && Array.isArray(item.items)) {
                    const result = validateItems(item.items);
                    if (!result.isValid) {
                        return result;
                    }
                }
            }
            return { isValid: true };
        };
        return validateItems(queryItems);
    }
    const convertQueryData = async (data, ConvertRate, CurencyDecimalPlace, setTypeing) => {
        const processItems = async (items) => {
            return Promise.all(
                items.map(async (item) => {
                    const simpleOperators = ["=", "!=", "<", ">"]
                    if (item.type === "condition") {
                        if (item.Currency === 'YES') {
                            if (item.value !== undefined && item.value !== null && item.value !== "") {
                                if (setTypeing === "Submit") {
                                    const convertedValue = await convertCurrency(ConvertRate, Number(item.value));
                                    item.value = Number(convertedValue);
                                } else if (setTypeing === "Seting") {
                                    const exchangedValue = await ExchangeCurrency(Number(item.value), ConvertRate);
                                    item.value = Number(exchangedValue?.toFixed(CurencyDecimalPlace));
                                }
                            }
                        }
                        if (setTypeing === "Submit") {
                            if (["competition", "contact_person", "followers", "child_case"].includes(item.field)) {
                                item.value = (item.value && item.value.length > 0)
                                    ? item.value.join(',')
                                    : null;
                            }
                            if (item.Key === 'Date') {
                                if (item.field === "created_at" || item.field === "dealCreatedAt" || item.field === "modified_at") {
                                    if (simpleOperators.includes(item.operator)) {
                                        item.value = convertDateFromProfile(item.value, companyProfile, profile)
                                    }
                                }
                            }
                        } else if (setTypeing === "Seting") {
                            if (["competition", "contact_person", "followers", "child_case"].includes(item.field)) {
                                item.value = item.value
                                    ? item.value.split(',').map(user => Number(user))
                                    : [];
                            }
                            if (item.Key === 'Date') {
                                if (item.field === "created_at" || item.field === "dealCreatedAt" || item.field === "modified_at") {
                                    if (simpleOperators.includes(item.operator)) {
                                        item.value = convertDateFromCompany(item.value, profile, companyProfile)
                                    }
                                }
                            }
                        }
                    } else if (item.type === "group" && Array.isArray(item.items)) {
                        item.items = await processItems(item.items);  // Recursively process sub-items
                    }

                    return item;
                })
            );
        };
        return processItems(data);
    };
    const buildQuery = async (tableName, groupData) => {
        const clausePromises = groupData.items.map(async (item, index) => {
            let clause = "";
            if (item.type === "condition") {
                const isDropDownField = item.Key === "Drop Down";
                const isNumericField = item.Key === "Numbers";
                const isDateField = item.Key === "Date";
                const isValidNumber = item.value !== '' && !Number.isNaN(Number(item.value));
                const isDropDownMultiple = item.Key === "Drop Down" && (item.field === "competition" || item.field === "contact_person" || item.field === "followers" || item.field === "child_case");
                if (item.operator === "IS NULL" || item.operator === "IS NOT NULL") {
                    clause = `${tableName}.${item.field} ${item.operator}`;
                }
                else if (isDropDownMultiple && item.operator === "=") {
                    clause = `${tableName}.${item.field} LIKE '%${item.value}%'`;
                }
                else if (isDropDownMultiple && item.operator === "!=") {
                    clause = `${tableName}.${item.field} NOT LIKE '%${item.value}%'`;
                }
                else if (item.operator === "contains") {
                    clause = `${tableName}.${item.field} LIKE '%${item.value}%'`;
                }
                else if (item.operator === "NOT LIKE") {
                    clause = `${tableName}.${item.field} NOT LIKE '%${item.value}%'`;
                }
                else if (item.operator === "starts_with") {
                    clause = `${tableName}.${item.field} LIKE '${item.value}%'`;
                }
                else if (item.operator === "ends_with") {
                    clause = `${tableName}.${item.field} LIKE '%${item.value}'`;
                }
                else if (isDateField) {
                    if (item.field === "created_at" || item.field === "dealCreatedAt" || item.field === "modified_at") {
                        const supportedViews = ["Lead", "Contact", "Account", "Deal", "Task"];
                        const datefrom = ["today", "yesterday"];
                        if (supportedViews.includes("User")) {
                            const DateOperators = ["=", "!=", "<"];
                            if (DateOperators.includes(item.operator)) {
                                clause = `${tableName}.${item.field} ${item.operator} '${item.value}'`;
                            }
                            else if (datefrom.includes(item.operator)) {
                                clause = `${tableName}.${item.field} = {{${item.operator}}}`;
                            }
                            else {
                                clause = `${tableName}.${item.field} BETWEEN {{${item.operator}_start_date}} AND {{${item.operator}_end_date}}`;
                            }
                        } else {
                            const DateOperators = ["=", "!=", "<"];
                            if (DateOperators.includes(item.operator)) {
                                const dates = await DateforQueryBuilder(item.operator, "DatesTime", item.value, companyProfile, profile)
                                clause = `${tableName}.${item.field} BETWEEN '${dates.start}' AND '${dates.end}'`;
                            }
                            // else if (datefrom.includes(item.operator)) {
                            //     clause = `${tableName}.${item.field} = {{${item.operator}}}`;
                            // }
                            else {
                                clause = `${tableName}.${item.field} BETWEEN {{${item.operator}_start_date_time}} AND {{${item.operator}_end_date_time}}`;
                            }
                        }
                    }
                    else {
                        const simpleOperators = ["=", "!=", "<", ">", "today", "yesterday", "tomorrow"];
                        const datefrom = ["today", "yesterday", "tomorrow"];
                        if (simpleOperators.includes(item.operator)) {
                            if (datefrom.includes(item.operator)) {
                                clause = `${tableName}.${item.field} = {{${item.operator}}}`;
                            } else {
                                clause = `${tableName}.${item.field} ${item.operator} '${item.value}'`;
                            }
                        } else {
                            clause = `${tableName}.${item.field} BETWEEN {{${item.operator}_start_date}} AND {{${item.operator}_end_date}}`;
                        }
                    }
                }
                else {
                    clause = `${tableName}.${item.field} ${item.operator} ${(isNumericField || (isDropDownField && isValidNumber))
                        ? item.value
                        : `'${item.value}'`
                        }`;

                }
            } else if (item.type === "group") {
                const inner = await buildQuery(tableName, item);
                const conditionCount = item.items.filter(
                    (child) => child.type === "condition"
                ).length;
                const shouldWrap = conditionCount > 1;
                clause = shouldWrap ? `(${inner})` : inner;
                // clause = `(${inner})`;
            }
            if (index > 0 && item.relationWithPrevious) {
                clause = `${item.relationWithPrevious.toUpperCase()} ${clause}`;
            }
            return clause;
        });
        const parts = await Promise.all(clausePromises);
        return parts.join(" ");
    };
    const normalizeValue = (value) => {
        if (value === undefined || value === "") return null;
        return value;
    };
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };
    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    // const getChangedFields = (newData, oldData) => {
    //     return Object.keys(newData).reduce((acc, key) => {
    //         if (Array.isArray(newData[key]) && Array.isArray(oldData[key])) {
    //             if (JSON.stringify(newData[key]) !== JSON.stringify(oldData[key])) {
    //                 acc[key] = newData[key];
    //             }
    //         } else if (newData[key] !== oldData[key]) {
    //             acc[key] = newData[key];
    //         }
    //         return acc;
    //     }, {});
    // };
    const CloseDrawer = () => {
        setActiveKey("1")
        setCancelConfirmOpen(false)
        setEdit(false)
        setEdit1(false)
        setDisplayData()
        form.setFieldsValue({
            calculationMethod: undefined,
            description: undefined,
            fixedPecentagePriceUp: undefined,
            manufacturerName: undefined,
            prodcutCategory: undefined,
            productCode: undefined,
            productName: undefined,
            productcostperunitmonth: undefined,
            sellingPricePerunitPerMonth: undefined,
        })
        setFileList([])
        setProductActive(true)
        setProductImg()
        setChecked(false);
        setProductCost()
        setCalculation()
        setMethod()
        setAction("Globally")
        setGroup()
        setViewPopupType()
        OpenProduct()
    }
    const HandleIsModalVisible = (value) => {
        setIsModalVisible(value)
    }
    const handleCalculationMethod = (productCosts, method, calculationValue) => {
        if (productCosts && productCosts !== "" && calculationValue && calculationValue !== "") {
            let sp = 0;
            if (method === "Fixed") {
                const numCalculationValue = Number(calculationValue);
                if (Number.isNaN(numCalculationValue)) {
                    return;
                }
                sp = numCalculationValue
                form.setFieldsValue({
                    sellingPricePerunitPerMonth: numCalculationValue?.toFixed(CurencyDecimalPlace)
                });
            } else
                if (method === "Percentage %") {
                    const numCalculationValue = Number(calculationValue);
                    const numproductCosts = Number(productCosts);
                    if (Number.isNaN(numCalculationValue) && Number.isNaN(numproductCosts)) {
                        return;
                    }
                    sp = numproductCosts * (1 + numCalculationValue / 100)
                    form.setFieldsValue({
                        sellingPricePerunitPerMonth: (numproductCosts * (1 + numCalculationValue / 100))?.toFixed(CurencyDecimalPlace)
                    });
                } else
                    if (method === "Price Up") {
                        const numCalculationValue = Number(calculationValue);
                        const numproductCosts = Number(productCosts);
                        if (Number.isNaN(numCalculationValue) && Number.isNaN(numproductCosts)) {
                            return;
                        }
                        sp = numproductCosts + numCalculationValue
                        form.setFieldsValue({
                            sellingPricePerunitPerMonth: (numproductCosts + numCalculationValue)?.toFixed(CurencyDecimalPlace)
                        });
                    }
            const numproductCosts = Number(productCosts);
            if (Number.isNaN(numproductCosts)) {
                return;
            }
            const productMargin = sp - numproductCosts
            setMargin(productMargin?.toFixed(CurencyDecimalPlace))
            form.setFieldsValue({
                productMarginperunitmonth: productMargin?.toFixed(CurencyDecimalPlace)
            });
        }
        else {
            setMargin()
            form.setFieldsValue({
                sellingPricePerunitPerMonth: null,
                productMarginperunitmonth: null,
            });
        }
    }
    const handleCheckboxChange = (e) => {
        setChecked(e.target.checked);
        setTimeout(() => {
            if (e.target.checked) {
                form.setFieldsValue({
                    fixedPecentagePriceUp: null,
                    sellingPricePerunitPerMonth: null,
                    productcostperunitmonth: null,
                    productMarginperunitmonth: null,
                    calculationMethod: null,
                    manufacturerName: null
                });
                setProductCost()
                setCalculation()
                setMethod()
                setMargin()
            }
        }, 0);
    };
    const handleProductCosts = (value) => {
        setProductCost(value)
        handleCalculationMethod(value, method, calculation)
    }
    const GetProductCategory = async () => {
        try {
            const data = await getProdCategory()
            const options = data.map((option, i) => (
                <Option value={option.productCategory} key={i}>
                    {option.productCategory}
                </Option>))
            setProductCat(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const handleMethodChange = (value) => {
        setMethod(value)
        handleCalculationMethod(productCost, value, calculation)
    }
    const handleCalculation = (e) => {
        setCalculation(e.target.value);
        handleCalculationMethod(productCost, method, e.target.value)
    }
    const generateUniqueCode = (productCode, existingData) => {
        let newCode;
        const existingCodes = new Set(existingData.map(item => item.productCode));
        do {
            const randomNumber = Math.floor(100000 + Math.random() * 900000);
            newCode = `${productCode}-${randomNumber}`;
        } while (existingCodes.has(newCode));
        return newCode;
    }
    const validateProductCode = (_, value) => {
        const allowedRegex = /^[A-Za-z0-9-]+$/;
        if (!allowedRegex.test(value)) {
            return Promise.reject(
                new Error("Only letters, numbers, and hyphens (-) are allowed")
            );
        }
        if (value.length > 15) {
            return Promise.reject(
                new Error("Account number cannot exceed 15 characters")
            );
        }
        const Projects = allProject
            .filter(item => item.dealProductId !== drawerId)
        const existingCodes = Projects.map(item => item.productCode)
        if (existingCodes.includes(value)) {
            return Promise.reject(new Error("This code already exists"));
        }
        return Promise.resolve();
    };
    const getProject = async (type) => {
        try {
            const data = await getCompanyProject()
            if (type === "Create") {
                const newCode = generateUniqueCode("PRD", data);
                form.setFieldsValue({
                    productCode: newCode,
                })
            }
            setAllProject(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    async function setInitialData(value) {
        const commonData = {
            productImg: normalizeValue(value.productImg),
            prodcutCategory: normalizeValue(value.prodcutCategory),
            productName: normalizeValue(value.productName),
            description: normalizeValue(value.description),
            productCode: normalizeValue(value.productCode),
            productActive: normalizeValue(value.productActive),
            resell: normalizeValue(value.resell),
            manufacturerName: normalizeValue(value.manufacturerName),
            productFiles: (value.productFiles || []),
            marginCalculationMethod: normalizeValue(value.marginCalculationMethod),
            sellingPricePerUnitPerMonth: normalizeValue(value.sellingPricePerUnitPerMonth),
            productCostPerUnitMonth: normalizeValue(value.productCostPerUnitMonth),
            fixedPecentagePriceUp: normalizeValue(value.fixedPecentagePriceUp),
            productMarginPerUnitMonth: normalizeValue(value.productMarginPerUnitMonth),
            sharedWith: value.sharedWith || "Globally",
            query: value?.query,
            queryBuilder: value?.queryBuilder
        }
        const adminExtra = {
            targetIndustries: normalizeValue(value?.targetIndustries),
            keyFeatures: normalizeValue(value?.keyFeatures),
            competitiveAdvantages: normalizeValue(value?.competitiveAdvantages),
            buyerPersons: normalizeValue(value?.buyerPersons),
            targetDepartments: normalizeValue(value?.targetDepartments),
            directCompetitors: normalizeValue(value?.directCompetitors),
            specialInstructionsforBots: normalizeValue(value?.specialInstructionsforBots),
        };
        setLeadInitial({
            ...commonData,
            ...(profile.roleName === "Administrator" ? adminExtra : {})
        });
    }
    const setUserData = async (value) => {
        if (value !== undefined) {
            const sellingPrice = value.sellingPricePerUnitPerMonth
                ? await ExchangeCurrency(Number(value.sellingPricePerUnitPerMonth), ConvertRate)
                : value.sellingPricePerUnitPerMonth;
            const productCostPrice = value.productCostPerUnitMonth
                ? await ExchangeCurrency(Number(value.productCostPerUnitMonth), ConvertRate)
                : value.productCostPerUnitMonth;
            const productMarginPerUnitMonths = value.productMarginPerUnitMonth
                ? await ExchangeCurrency(Number(value.productMarginPerUnitMonth), ConvertRate)
                : value.productMarginPerUnitMonth;
            const calculations = (value.marginCalculationMethod === "Fixed" || value.marginCalculationMethod === "Price Up") ?
                (value.fixedPecentagePriceUp
                    ? await ExchangeCurrency(Number(value.fixedPecentagePriceUp), ConvertRate)
                    : value.fixedPecentagePriceUp)
                : value.fixedPecentagePriceUp;
            const commonData = {
                calculationMethod: value.marginCalculationMethod,
                description: value.description,
                fixedPecentagePriceUp: calculations ? (value.marginCalculationMethod === "Fixed" || value.marginCalculationMethod === "Price Up") ? Number(calculations?.toFixed(CurencyDecimalPlace)) : calculations : calculations,
                manufacturerName: value.manufacturerName,
                prodcutCategory: value.prodcutCategory,
                productCode: value.productCode,
                productName: value.productName,
                productcostperunitmonth: productCostPrice ? Number(productCostPrice?.toFixed(CurencyDecimalPlace)) : productCostPrice,
                sellingPricePerunitPerMonth: sellingPrice ? Number(sellingPrice?.toFixed(CurencyDecimalPlace)) : sellingPrice,
            }
            const adminExtra = {
                targetIndustries: value?.targetIndustries ? splitToArray(value.targetIndustries) : [],
                keyFeatures: value?.keyFeatures,
                competitiveAdvantages: value?.competitiveAdvantages,
                buyerPersons: value?.buyerPersons ? splitToArray(value.buyerPersons) : [],
                targetDepartments: value?.targetDepartments ? splitToArray(value.targetDepartments) : [],
                directCompetitors: value?.directCompetitors ? splitToArray(value.directCompetitors) : [],
                specialInstructionsforBots: value?.specialInstructionsforBots,
            };
            form.setFieldsValue({
                ...commonData,
                ...(profile.roleName === "Administrator" ? adminExtra : {})
            });
            setFileList(value.productFiles || [])
            setProductActive(value.productActive === "Yes")
            setProductImg(value.productImg)
            setChecked(value.resell);
            setProductCost(productCostPrice ? Number(productCostPrice?.toFixed(CurencyDecimalPlace)) : productCostPrice)
            setCalculation(calculations ? (value.marginCalculationMethod === "Fixed" || value.marginCalculationMethod === "Price Up") ? Number(calculations?.toFixed(CurencyDecimalPlace)) : calculations : calculations)
            setMethod(value.marginCalculationMethod)
            if (value.productActive === "Yes" && productCostPrice && value.marginCalculationMethod && calculations) {
                handleCalculationMethod(productCostPrice ? Number(productCostPrice?.toFixed(CurencyDecimalPlace)) : productCostPrice, value.marginCalculationMethod, calculations ? (value.marginCalculationMethod === "Fixed" || value.marginCalculationMethod === "Price Up") ? Number(calculations?.toFixed(CurencyDecimalPlace)) : calculations : calculations)
            }
            const updatedPerson = {
                ...value,
                productCostPerUnitMonth: productCostPrice ? Number(productCostPrice?.toFixed(CurencyDecimalPlace)) : productCostPrice,
                sellingPricePerUnitPerMonth: sellingPrice ? Number(sellingPrice?.toFixed(CurencyDecimalPlace)) : sellingPrice,
                productMarginPerUnitMonth: productMarginPerUnitMonths ? Number(productMarginPerUnitMonths?.toFixed(CurencyDecimalPlace)) : productMarginPerUnitMonths,
                fixedPecentagePriceUp: calculations ? (value.marginCalculationMethod === "Fixed" || value.marginCalculationMethod === "Price Up") ? Number(calculations?.toFixed(CurencyDecimalPlace)) : calculations : calculations,
            };
            setAction(updatedPerson.sharedWith || "Globally")
            if (updatedPerson.sharedWith === "Specific_user") {
                const copiedGroup = JSON.parse(JSON.stringify(updatedPerson?.query));
                const processedItems = await convertQueryData(copiedGroup.items, "Seting");
                copiedGroup.items = processedItems;
                setGroup(copiedGroup)
                setViewPopupType("Edit")
            } else {
                setGroup()
                setViewPopupType("Create")
            }
            setDisplayData(updatedPerson)
        }
    }
    async function deleteMenu(id) {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick1(true)
        let hideMessage;
        setDisplay(true)
        try {
            hideMessage = message.loading("Loading...", 0);
            const Response = await deleteDealProduct(id)
            if (Response.status === 200) {
                if (Array.isArray(Response.data) && Response.data.length > 0 && Response.data[0].entityType !== 'Success') {
                    setErrorData(Response.data);
                    setIsModalVisible(true);
                    setConfirmPopup(false)
                    setDisplay(false)
                } else {
                    setConfirmPopup(false)
                    GetAll()
                    setDisplay(false)
                    setEdit(false)
                    if (Response.data[0].entityMessage === AutomationMessage) {
                        successMessage("Automation rule triggered", Response.data[0].entityMessage)
                    } else {
                        message.success(
                            <span>
                                Product <strong>{Response?.data?.[0]?.entityName}</strong> has been deleted successfully
                            </span>
                        );
                    }
                    // message.success("Product deleted")
                    CloseDrawer()
                }
                loadingRef.current = false;
                setDoubleClick1(false)
                hideMessage();
            }
        } catch (error) {
            loadingRef.current = false;
            setDoubleClick1(false)
            hideMessage();
            setDisplay(false)
            message.error(error)
        }
    }
    async function getData(id) {
        try {
            const response = await getProductDetails(id);
            setUserData(response);
            setInitialData(response)
        } catch (error) {
            message.error(error);
        }
    }
    const FileUpload = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: 'image/*',
        action: `${getBaseURL()}/usermgmt/uploadFile`, // api for image upload
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                // setState({ ...state, file: info.file, list: info.fileList });
            }
            if (status === 'done') {
                setProductImg(info.file.response.mediaUrl);// to set that image url
                setDeleteOpen(true)
                message.success(`${info.file.name} File upload successful`);
            } else if (status === 'error') {
                message.error(`${info.file.name} File upload failed`);
            }
        },
        listType: 'picture',
        // defaultFileList: [
        //     {
        //         url: imageUrl,
        //     }
        // ],
        showUploadList: false,
        // showUploadList: {
        //     showRemoveIcon: true,
        //     removeIcon: <FeatherIcon icon="trash-2" onClick={e => console.log(e, 'custom removeIcon event')} />,
        // },
    };
    async function AccountApi() {
        try {
            const data = await AccountsByAccountType()
            const filterData = data.filter((item) => item.account_type_name === "Vendor" || item.account_type_name === "Reseller")
            setAccount(filterData)
            setAccountbyType(data)
        }
        catch (error) {
            message.error(error)
        }

    }
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        setDisplay(true)
        if (action === "Specific_user") {
            const validation = RequiredValidity(group?.items);
            if (!validation.isValid) {
                message.error(validation.message);
                setDisplay(false)
                return;
            }
        }
        // message.warning("Loading...", 2)
        const {
            calculationMethod,
            description,
            manufacturerName,
            prodcutCategory,
            productCode,
            productName,
            sellingPricePerunitPerMonth,
            targetIndustries,
            buyerPersons,
            keyFeatures,
            competitiveAdvantages,
            directCompetitors,
            targetDepartments,
            specialInstructionsforBots
        } = values;
        const sellingPrice = sellingPricePerunitPerMonth
            ? await convertCurrency(ConvertRate, Number(sellingPricePerunitPerMonth))
            : sellingPricePerunitPerMonth;
        const productCostPrice = productCost
            ? await convertCurrency(ConvertRate, Number(productCost))
            : productCost;
        const marginCost = margin
            ? await convertCurrency(ConvertRate, Number(margin))
            : margin;
        const calculations = (calculationMethod === "Fixed" || calculationMethod === "Price Up") ?
            (calculation
                ? await convertCurrency(ConvertRate, Number(calculation))
                : calculation)
            : calculation;
        let SaveQuery = "";
        let copiedGroup;
        if (action === "Specific_user") {
            copiedGroup = JSON.parse(JSON.stringify(group));
            const processedItems = await convertQueryData(copiedGroup.items, "Submit");
            copiedGroup.items = processedItems;
            const tableName = entityTableMap.find(t => t.entityName === "Users")?.tableName || "";
            const finalQuery = await buildQuery(tableName, copiedGroup);
            if (tableName) {
                SaveQuery = `SELECT {{*}} FROM ${tableName} WHERE (${finalQuery})`;
            } else {
                SaveQuery = finalQuery;
            }
        }
        // if (action === "Specific_user") {
        //     if (!validateQueryData(group?.items)) {
        //         setDisplay(false)
        //         return;
        //     }
        // }
        const payload = {
            productImg: normalizeValue(productImg),
            prodcutCategory: normalizeValue(prodcutCategory),
            productName: normalizeValue(productName),
            description: normalizeValue(description),
            productCode: normalizeValue(productCode),
            productActive: normalizeValue(productActive ? "Yes" : "No"),
            resell: normalizeValue(checked),
            manufacturerName: normalizeValue(manufacturerName),
            productFiles: FILEList,
            marginCalculationMethod: normalizeValue(calculationMethod),
            sellingPricePerUnitPerMonth: normalizeValue(sellingPrice),
            productCostPerUnitMonth: normalizeValue(productCostPrice),
            fixedPecentagePriceUp: normalizeValue(calculations),
            productMarginPerUnitMonth: normalizeValue(marginCost),
            sharedWith: normalizeValue((profile.roleName === "Administrator" || (profile.companyRole === "Administrator" || profile.companyRole === "CEO")) ? action : "None"),
            query: action === "Specific_user" ? copiedGroup : null,
            queryBuilder: action === "Specific_user" ? SaveQuery : null,
        }
        if (profile.roleName === "Administrator") {
            payload.targetIndustries = normalizeValue(arrayToString(targetIndustries));
            payload.keyFeatures = normalizeValue(keyFeatures);
            payload.competitiveAdvantages = normalizeValue(competitiveAdvantages);
            payload.buyerPersons = normalizeValue(arrayToString(buyerPersons));
            payload.directCompetitors = normalizeValue(arrayToString(directCompetitors));
            payload.targetDepartments = normalizeValue(arrayToString(targetDepartments));
            payload.specialInstructionsforBots = normalizeValue(specialInstructionsforBots);
        }
        const updatedFields = getChangedFields(payload, leadInitial);
        if (Object.keys(updatedFields).length === 0) {
            message.success("Product updated")
            GetAll()
            setDisplay(false)
            setEdit(false)
            CloseDrawer()
            return;
        }
        if (drawerType === "Update") {
            try {
                if (updatedFields.queryBuilder && !('sharedWith' in updatedFields)) {
                    updatedFields.sharedWith = normalizeValue(
                        (profile.roleName === "Administrator" || profile.companyRole === "Administrator" || profile.companyRole === "CEO")
                            ? action
                            : "None"
                    );
                }
                hideMessage = message.loading("Loading...", 0);
                const response = await updateDealProduct(updatedFields, drawerId)
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        setConfirmPopup(false)
                        hideMessage();
                        setDisplay(false)
                        loadingRef.current = false;
                        setDoubleClick(false)
                    }
                    else {
                        GetAll()
                        hideMessage();
                        setDisplay(false)
                        setEdit(false)
                        if (response.data[0].message === AutomationMessage) {
                            successMessage("Automation rule triggered", response.data[0].message)
                        } else {
                            message.success(
                                <span>
                                    Product <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                </span>
                            );
                        }
                        loadingRef.current = false;
                        setDoubleClick(false)
                        CloseDrawer()
                    }
                }
            }
            catch (error) {
                loadingRef.current = false;
                setDoubleClick(false)
                hideMessage();
                setDisplay(false)
                message.error(error)
            }
        }
        if (drawerType !== "Update") {
            try {
                hideMessage = message.loading("Loading...", 0);
                const response = await createDealProduct(updatedFields)
                if (response.status === 201) {
                    GetAll()
                    hideMessage();
                    setDisplay(false)
                    setEdit(false)
                    if (response?.data === AutomationMessage) {
                        successMessage("Automation rule triggered", response?.data)
                    } else {
                        message.success(response?.data)
                    }
                    loadingRef.current = false;
                    setDoubleClick(false)
                    CloseDrawer()
                }
            } catch (error) {
                loadingRef.current = false;
                setDoubleClick(false)
                hideMessage();
                setDisplay(false)
                message.error(error)
            }
        }
    }
    const handleDeleteImage = () => {
        setProductImg(null);
        setDeleteOpen(false);
    };
    const OnClickofDelete = (value) => {
        setConfirmPopup(true)
        setDeleteId(value)
    }
    const handleCheckbox = (value) => {
        setAction(value)
        if (value === "Specific_user") {
            if (!group) {
                setViewPopupType("Create")
            }
        }
    }
    const getQueryFields = async () => {
        try {
            const response = await getQueryFieldsByType("Users", "Views")
            if (response.status === 200) {
                setQueryField(response.data)
            }
        } catch (error) {
            message.error(error)
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            AccountApi(),
            getQueryFields(),
            GetProductCategory(),
            getAllTableName(),
            IndustryDataApi()
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (drawerType) {
            if (defaultCurrency) {
                setCurrencySetting(defaultCurrency);
            }
        }
    }, [drawerType]);
    useEffect(() => {
        if (drawerType && drawerOpen) {
            fetchAll();
        }
    }, [drawerType, drawerOpen]);
    useEffect(() => {
        if (currencySettings) {
            if (drawerType === "Update" && drawerId) {
                setDisplayData()
                getData(drawerId)
                getProject("Update")
            }
            if (drawerType === "Create") {
                getProject("Create")
                setEdit(true)
                form.setFieldsValue({
                    calculationMethod: undefined,
                    description: undefined,
                    fixedPecentagePriceUp: undefined,
                    manufacturerName: undefined,
                    prodcutCategory: undefined,
                    productCode: undefined,
                    productName: undefined,
                    productcostperunitmonth: undefined,
                    sellingPricePerunitPerMonth: undefined,
                })
                setLeadInitial(profile.roleName === "Administrator" ? InitialData.ProductData : InitialData.ProductData1)
                setFileList([])
                setProductActive(true)
                setProductImg()
                setChecked(false);
                setProductCost()
                setCalculation()
                setMethod()
                setAction("Globally")
                setGroup()
                setViewPopupType("Create")
                setDisplayData("Create")
            }
        }
    }, [drawerType, drawerId, currencySettings]);
    const CloseDrawer2 = () => {
        if (activeKey === "1") { setEdit(false) } else { setEdit1(false) }
        getData(drawerId)
    }
    const PageCancel = () => {
        if (drawerType === "Update" && drawerId) {
            CloseDrawer2()
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    const PageCancel1 = () => {
        if (edit || edit1) {
            setCancelConfirmOpen(true)
        }
        else {
            CloseDrawer()
        }
    }
    const getRefreshtheTable = () => {
        GetAll()
        setDisplay(false)
        setEdit(false)
        CloseDrawer()
        setConfirmPopup(false)
    }
    const pageContent1 = (<AddUser>
        <div className="user-info-form">
            <BasicFormWrapper>
                <VerticalFormStyleWrap>
                    <div className="add-product-block">
                        <div style={{ margin: 40 }}>
                            <Heading as="h5">Product Information</Heading>
                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                <Col span={8} style={{ marginBottom: 30 }}>
                                    <Form.Item label="Product Name" name="productName"
                                        id="productName"
                                        rules={edit ? [{ required: true, message: 'Please enter product name', }, {
                                            validator: (_, value) => {
                                                const error = validateShortText(value, 50);
                                                if (error) {
                                                    return Promise.reject(new Error(error));
                                                }
                                                return Promise.resolve();
                                            },
                                        }] : [{ required: false }]}>
                                        {edit ? <Input placeholder="Enter Product Name" /> :
                                            <span>{displayData?.productName}</span>
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={8} style={{ marginBottom: 30 }}>
                                    <Form.Item label="Product Category" name="prodcutCategory"
                                        id="prodcutCategory"
                                        rules={edit ? [{ required: true, message: 'Please select a product category', }] : [{ required: false }]}
                                    >
                                        {edit ? <Select style={{ width: '100%' }}
                                            placeholder="Select Product Category">
                                            {productCat}
                                        </Select> :
                                            <span>{displayData?.prodcutCategory}</span>
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={8} style={{ marginBottom: 30 }}>
                                    <Form.Item label="Product Code" name="productCode"
                                        id="productCode" rules={edit ? [{ required: true, message: 'Please enter product code', }, { validator: validateProductCode }] : [{ required: false }]}>
                                        {edit ? <Input placeholder='Enter Product Code' /> :
                                            <span>{displayData?.productCode}</span>
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={8} style={{ marginBottom: 30 }}>
                                    <Form.Item label={`Unit Price (${currencySettings?.currency})`} name="sellingPricePerunitPerMonth"
                                        id="sellingPricePerunitPerMonth" rules={edit ? [{ required: true, message: 'Please enter unit price' }, {
                                            validator: async (_, value) => {
                                                if (value === undefined || value === null || value === '') {
                                                    return Promise.resolve();
                                                }
                                                // Strict numeric check (digits with optional 1 dot)
                                                const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                if (!basicNumberCheck.test(value)) {
                                                    return Promise.reject(new Error('Please enter a valid number'));
                                                }

                                                // Check decimal places (must be ≤ 2)
                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                if (!decimalRegex.test(value)) {
                                                    return Promise.reject(
                                                        new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                    );
                                                }
                                            }
                                        },
                                        ] : [{ required: false }]
                                        } >
                                        {
                                            edit ?
                                                <Input placeholder='Enter Unit Price' disabled={checked} prefix={currencySettings?.symbol} />
                                                :
                                                <>{currencySettings?.symbol}<span>
                                                    {displayData?.sellingPricePerUnitPerMonth?.toLocaleString()}
                                                </span>
                                                </>
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={8} style={{ marginBottom: 30 }}>
                                    <Form.Item
                                        label="Product Active?"
                                    />
                                    {edit ? <Switch
                                        checked={productActive}
                                        onChange={value => setProductActive(value)}
                                    /> :
                                        <span>{displayData?.productActive === "Yes" ? "Active" : "Inactive"}</span>
                                    }
                                </Col>
                                <Col span={8} style={{ marginBottom: 30 }}>
                                    <Form.Item label="Resell?">
                                        {edit ? <Checkbox onChange={handleCheckboxChange}
                                            checked={checked}>Yes</Checkbox> :
                                            <span>{checked ? "Yes" : "No"}</span>
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={24} style={{ marginBottom: 30 }}>
                                    <Form.Item label="Description" name="description" id="description" rules={edit ? 
                                        [
                                            {
                                                validator: (_, value) => {
                                                    const error = validateDescriptionField(value, 2500);
                                                    if (error) {
                                                        return Promise.reject(new Error(error));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            },
                                        ]:[]
                                    }>
                                        {edit ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Description' /> :
                                            <span>{displayData?.description}</span>
                                        }
                                    </Form.Item>
                                </Col>
                                {/* {(displayData?.resell || checked) && <> */}
                                {checked && <>
                                    <Col span={8} style={{ marginBottom: 30 }}>
                                        <Form.Item
                                            label="Vendor Name"
                                            name="manufacturerName" id="manufacturerName">
                                            {edit ? <Select style={{ width: '100%' }}
                                                placeholder="Select Vendor Name"
                                                showSearch allowClear optionLabelProp="label"
                                                optionFilterProp="children"
                                                filterOption={(input, option) => {
                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                        const username = String(usernameElement.props.children);
                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                    }
                                                    return false;
                                                }
                                                }>
                                                {account.map((option, i) => (
                                                    <Option value={option.account_name} key={i} label={(
                                                        <div style={{ display: 'flex', alignItems: 'center' }} >
                                                            <div className='Div_flex2'>
                                                                <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                                                    {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                        < img src={option.account_profile} alt="profile" />
                                                                        :
                                                                        <span className="image_icon AccountIcon">
                                                                            {option.account_name.slice(0, 1).toUpperCase()}
                                                                        </span>
                                                                    }
                                                                    <span className='div-ellipsis'>{option.account_name}</span>
                                                                </div>
                                                            </div>
                                                        </div>)}>
                                                        <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                                                            <div>
                                                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                    < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                    :
                                                                    <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                        {option.account_name.slice(0, 1).toUpperCase()}
                                                                    </span>
                                                                }</div>
                                                            <div>
                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                <p style={{ margin: 0 }}>{option.account_number}</p>
                                                            </div>
                                                        </div>
                                                    </Option>))}
                                            </Select> :
                                                <span>{displayData?.manufacturerName}</span>
                                            }
                                        </Form.Item>
                                    </Col>
                                    <Col span={8} style={{ marginBottom: 30 }}>
                                        <Form.Item label={`Product Cost (per Unit) (${currencySettings?.currency})`} name="productcostperunitmonth"
                                            id="productcostperunitmonth"
                                            rules={
                                                (edit &&checked) ? [{ required: true, message: 'Please enter product cost (per unit)' },
                                            {
                                                validator: async (_, value) => {
                                                    if (value === undefined || value === null || value === '') {
                                                        return Promise.resolve();
                                                    }
                                                    // Strict numeric check (digits with optional 1 dot)
                                                    const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                    if (!basicNumberCheck.test(value)) {
                                                        return Promise.reject(new Error('Please enter a valid number'));
                                                    }

                                                    // Check decimal places (must be ≤ 2)
                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                    if (!decimalRegex.test(value)) {
                                                        return Promise.reject(
                                                            new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                        );
                                                    }
                                                }

                                            },
                                            ] : [{ required: false }]}>

                                            {edit ? <Input placeholder='Enter Product Cost Per Unit' value={productCost}
                                                onChange={(e) => handleProductCosts(e.target.value)} prefix={currencySettings?.symbol} />
                                                :
                                                <>{currencySettings?.symbol}<span>
                                                    {displayData?.productCostPerUnitMonth?.toLocaleString()}
                                                </span>
                                                </>
                                            }
                                        </Form.Item>
                                    </Col>
                                    <Col span={8} style={{ marginBottom: 30 }}>
                                        <Form.Item rules={(edit&&checked) ? [{ required: true, message: 'Select margin calculation method' }] : [{ required: false }]}
                                            label="Margin Calculation Method" name="calculationMethod" id="calculationMethod">
                                            {edit ? <Select style={{ width: '100%' }}
                                                placeholder="Select Calculation Method" onChange={handleMethodChange}>
                                                <Option value="Fixed">Fixed</Option>
                                                <Option value="Percentage %">Percentage %</Option>
                                                <Option value="Price Up">Price Up</Option>
                                            </Select> :
                                                <span>{displayData?.marginCalculationMethod}</span>
                                            }
                                        </Form.Item>
                                    </Col>

                                    <Col span={8} style={{ marginBottom: 30 }}>
                                        <Form.Item label={method !== undefined ? `${method} ${method !== "Percentage %"
                                            ? `(${currencySettings?.currency})` : ""}` :
                                            `Fixed (${currencySettings?.currency})/Pecentage %/Price Up (${currencySettings?.currency})`} name="fixedPecentagePriceUp"
                                            id="fixedPecentagePriceUp"
                                            rules={(edit&&checked) ? [{
                                                required: true, message: `Please enter ${method !== undefined ? `${method} ${method !== "Percentage %"
                                                    ? `(${currencySettings?.currency})` : ""}` :
                                                    `Fixed (${currencySettings?.currency})/Pecentage %/Price Up (${currencySettings?.currency})`}`
                                            },
                                            {
                                                validator: async (_, value) => {
                                                    if (value === undefined || value === null || value === '') {
                                                        return Promise.resolve();
                                                    }
                                                    // Strict numeric check (digits with optional 1 dot)
                                                    const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                    if (!basicNumberCheck.test(value)) {
                                                        return Promise.reject(new Error('Please enter a valid number'));
                                                    }

                                                    // Check decimal places (must be ≤ 2)
                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                    if (!decimalRegex.test(value)) {
                                                        return Promise.reject(
                                                            new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                        );
                                                    }

                                                    const num = Number(value); // Now it's guaranteed to be a proper number

                                                    if (method === 'Percentage %' && (num < 0 || num > 100)) {
                                                        return Promise.reject(new Error('Percentage must be between 0 and 100'));
                                                    }

                                                    return Promise.resolve();
                                                }

                                            },
                                            ] : [{ required: false }]}>
                                            {edit ? <Input placeholder='Enter Cost' prefix={method === "Percentage %" ? "%" : currencySettings?.symbol}
                                                onChange={(e) => { handleCalculation(e) }} value={calculation} />
                                                :
                                                <>{method === "Percentage %" ? "%" : currencySettings?.symbol}<span>
                                                    {method === "Percentage %" ? displayData?.fixedPecentagePriceUp : displayData?.fixedPecentagePriceUp.toLocaleString()}
                                                </span>
                                                </>}
                                        </Form.Item>
                                    </Col>
                                    <Col span={8} style={{ marginBottom: 30 }}>
                                        <Form.Item label={`Product Margin (${currencySettings?.currency})`}
                                            rules={(edit&&checked) ? [{ required: true, message: 'Please enter product margin' }] : [{ required: false }]}
                                            name="productMarginperunitmonth"
                                            id="productMarginperunitmonth">
                                            {edit ? <Input placeholder='Product Margin Per Unit' value={margin} disabled prefix={currencySettings?.symbol} /> :
                                                <>{currencySettings?.symbol}<span>
                                                    {displayData?.productMarginPerUnitMonth?.toLocaleString()}
                                                </span>
                                                </>}
                                        </Form.Item>
                                    </Col>
                                </>}
                            </Row>
                            {(profile.roleName === "Administrator" || (profile.companyRole === "Administrator" || profile.companyRole === "CEO")) ?
                                <>
                                    <Heading as="h5">Shared With</Heading>
                                    <Radio.Group value={action} disabled={!edit} onChange={(e) => handleCheckbox(e.target.value)} style={{ width: '100%' }}>
                                        <Row gutter={30} style={{ margin: "20px 0px 0px" }}>
                                            <Col span={1} style={{ marginBottom: 30 }} />
                                            <Col span={6} style={{ marginBottom: 30 }} ><Radio value='Globally'>Globally</Radio></Col>
                                            <Col span={1} style={{ marginBottom: 30 }} />
                                            <Col span={6} style={{ marginBottom: 30 }} ><Radio value='Specific_user'>Specific Users</Radio></Col>
                                            <Col span={1} style={{ marginBottom: 30 }} />
                                            <Col span={6} style={{ marginBottom: 30 }} ><Radio value='None'>Only me</Radio></Col>
                                        </Row>
                                    </Radio.Group>
                                    {action === "Specific_user" &&
                                        <>
                                            {viewPopupType ?
                                                <div style={{ marginBottom: 30,padding:"0px 15px"}}>
                                                    <QueryBuilderFunction viewType="User" queryField={queryField} group={group} setGroup={setGroup} setUiLoad={setUiLoad} pageFor={viewPopupType === "Create" ? "New" : "Edit"}
                                                        pageFrom="ShareQuery" uiLoad={uiLoad} isEditable={edit} />
                                                </div> : <></>}
                                        </>
                                    }
                                </>
                                : <></>}
                            <RelatedDocUpload edit={edit} FILEList={FILEList} setFileList={setFileList} form={form} />
                            <Heading as="h5">Profile Picture</Heading>
                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                <Col span={8} style={{ marginBottom: 30 }}>
                                    <div >
                                        <figure className="photoUpload align-center-v" >
                                            {productImg !== null && productImg !== undefined && productImg !== "" ?
                                                < img src={productImg} alt="" />
                                                :
                                                drawerType === "Create" ?
                                                    <span className='details_span_Tag'>
                                                        P
                                                    </span>
                                                    :
                                                    <span className='details_span_Tag'>
                                                        {displayData?.productName?.slice(0, 1).toUpperCase()}
                                                    </span>
                                            }
                                            {edit && <figcaption>
                                                {deleteOption ? (
                                                    <div className='delete-div'>
                                                        <span className='delete-span'>
                                                            <FeatherIcon icon="trash-2" className="icon-svg" size={16} onClick={handleDeleteImage} />
                                                        </span>
                                                    </div>) :
                                                    (<div>

                                                        <ImgCrop aspect={1} cropShape="round" rotationSlider modalTitle="Crop Image">
                                                            <Upload {...FileUpload}>
                                                                <Link className="btn-upload" to={combinedUrl}>
                                                                    <FeatherIcon icon="camera" size={16} />
                                                                </Link>
                                                            </Upload>
                                                        </ImgCrop>
                                                    </div>)
                                                }
                                            </figcaption>}
                                        </figure>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </VerticalFormStyleWrap>
            </BasicFormWrapper>
        </div>
    </AddUser>)
    const pageContent2 = (<AddUser>
        <div className="user-info-form">
            <BasicFormWrapper>
                <VerticalFormStyleWrap>
                    <div className="add-product-block">
                        <div style={{ margin: 40 }}>
                            <Heading as="h5">Product Insights</Heading>
                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                <Col span={24} style={{ marginBottom: 30 }}>
                                    <Form.Item label="Target Industries" name="targetIndustries"
                                        id="targetIndustries"
                                        rules={edit1 ? [{ required: true, message: 'Please select a target industries', }] : [{ required: false }]}
                                    >
                                        {edit1 ? <Select style={{ width: '100%' }}
                                            placeholder="Select target industries" mode="multiple" className='MultiUiNew'>
                                            {industryData}
                                        </Select> :
                                            <div>
                                                {displayData?.targetIndustries
                                                    ? displayData.targetIndustries.split(",").map((person, index) => (
                                                        <Tag key={index} color="blue" style={{ marginBottom: 4, marginRight: 4 }}>
                                                            {person}
                                                        </Tag>
                                                    ))
                                                    : "Not Applicable"}
                                            </div>
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Row align="middle" gutter={16} style={{ marginBottom: 30 }}>
                                        <Col span={edit1 ? 21 : 24} >
                                            <Form.Item label="Target Departments" name="targetDepartments"
                                                id="targetDepartments"
                                                rules={edit1 ? [{ required: true, message: 'Please select a target departments', }] : [{ required: false }]}
                                            >
                                                {edit1 ? <Select mode="tags" className='MultiUiNew'
                                                    style={{ width: "100%" }}
                                                    placeholder="Type and press enter"
                                                    tokenSeparators={[","]}
                                                    open={false} /> :
                                                    <div>
                                                        {displayData?.targetDepartments
                                                            ? displayData.targetDepartments.split(",").map((person, index) => (
                                                                <Tag key={index} color="blue" style={{ marginBottom: 4, marginRight: 4 }}>
                                                                    {person}
                                                                </Tag>
                                                            ))
                                                            : "Not Applicable"}
                                                    </div>}
                                            </Form.Item>
                                        </Col>
                                        {edit1 ? <Col span={3} style={{ marginTop: 5 }}>
                                            <Form.Item label=" ">
                                                <Button size="small" className="gradient-button" disabled={display} onClick={() => getTargetDepartmentsData()}>
                                                    <AiIcon /> AI Assist
                                                </Button></Form.Item>
                                        </Col> : <></>}
                                    </Row>
                                </Col>
                                <Col span={24}>
                                    <Row align="middle" gutter={16} style={{ marginBottom: 30 }}>
                                        <Col span={edit1 ? 21 : 24} >
                                            <Form.Item label="Buyer Persons / Roles" name="buyerPersons"
                                                id="buyerPersons"
                                                rules={edit1 ? [{ required: true, message: 'Please enter buyer persons / roles', }] : [{ required: false }]}
                                            >
                                                {edit1 ? <Select
                                                    mode="tags"
                                                    className='MultiUiNew'
                                                    style={{ width: "100%" }}
                                                    placeholder="Type and press enter"
                                                    tokenSeparators={[","]}
                                                    open={false}
                                                /> :
                                                    <div>
                                                        {displayData?.buyerPersons
                                                            ? displayData.buyerPersons.split(",").map((person, index) => (
                                                                <Tag key={index} color="blue" style={{ marginBottom: 4, marginRight: 4 }}>
                                                                    {person}
                                                                </Tag>
                                                            ))
                                                            : "Not Applicable"}
                                                    </div>
                                                }
                                            </Form.Item>
                                        </Col>
                                        {edit1 ? <Col span={3} style={{ marginTop: 5 }}>
                                            <Form.Item label=" ">
                                                <Button size="small" className="gradient-button" disabled={display} onClick={() => getTargetRolesData()}>
                                                    <AiIcon /> AI Assist
                                                </Button></Form.Item>
                                        </Col> : <></>}</Row>
                                </Col>
                                <Col span={24}>
                                    <Row align="middle" gutter={16} style={{ marginBottom: 30 }}>
                                        <Col span={edit1 ? 21 : 24} >
                                            <Form.Item label="Direct Competitors"
                                                name="directCompetitors"
                                                id="directCompetitors"
                                                rules={edit1 ? [{ required: true, message: 'Please select a direct competitors', }] : [{ required: false }]}
                                            >
                                                {edit1 ?
                                                    <Select
                                                        mode="tags"
                                                        className='MultiUiNew'
                                                        style={{ width: "100%" }}
                                                        placeholder="Type and press enter"
                                                        tokenSeparators={[","]}
                                                    >
                                                        {accountbyType.filter((item) => item.account_type_name === "Competitor").map((option, i) => (
                                                            <Option value={option.account_name} key={i} >{option.account_name}</Option>))
                                                        }
                                                    </Select>
                                                    : <div>
                                                        {displayData?.directCompetitors
                                                            ? displayData.directCompetitors.split(",").map((person, index) => (
                                                                <Tag key={index} color="blue" style={{ marginBottom: 4, marginRight: 4 }}>
                                                                    {person}
                                                                </Tag>
                                                            ))
                                                            : "Not Applicable"}
                                                    </div>}
                                            </Form.Item>
                                        </Col>
                                        {edit1 ? <Col span={3} style={{ marginTop: 5 }}>
                                            <Form.Item label=" ">
                                                <Button size="small" className="gradient-button" disabled={display} onClick={() => getCompetitorsData()}>
                                                    <AiIcon /> AI Assist
                                                </Button></Form.Item>
                                        </Col> : <></>}</Row>
                                </Col>
                                <Col span={24} style={{ marginBottom: 30 }}>
                                    <Form.Item label="Key Features & Benefits" name="keyFeatures" id="keyFeatures" rules={edit1 ? [{ required: true, message: 'Please enter a key features & benefits', }] : [{ required: false }]}
                                    >
                                        {edit1 ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter key features & benefits' /> :
                                            <span>{displayData?.keyFeatures || "Not Applicable"}</span>
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={24} style={{ marginBottom: 30 }}>
                                    <Form.Item label="Competitive Advantages" name="competitiveAdvantages" id="competitiveAdvantages" rules={edit1 ? [{ required: true, message: 'Please enter a competitive advantages', }] : [{ required: false }]}>
                                        {edit1 ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter competitive advantages' /> :
                                            <span>{displayData?.competitiveAdvantages || "Not Applicable"}</span>
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={24} style={{ marginBottom: 30 }}>
                                    <Form.Item label="Special Instructions for Bots" name="specialInstructionsforBots" id="specialInstructionsforBots" >
                                        {edit1 ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter special instructions for bots' /> :
                                            <span>{displayData?.specialInstructionsforBots || "Not Applicable"}</span>
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </VerticalFormStyleWrap>
            </BasicFormWrapper>
        </div>
    </AddUser>)
    const onChange = (key) => {
        if (edit || edit1) {
            message.warning("Please save or cancel your changes before switching tabs");
            return;
        }
        setActiveKey(key);
    };
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    drawerType === "Update" ?
                        <span>
                            Update Product
                            {displayData?.productName && (
                                <>
                                    <span style={{ 
                                        margin: '0 10px', 
                                        color: '#d9d9d9', 
                                        fontWeight: 'normal' 
                                    }}>|</span>
                                    <span style={{ fontWeight: 'normal' }}>
                                        {displayData.productName}
                                    </span>
                                </>
                            )}
                        </span>
                        : "Create Product"
                }
                closable={false}
                placement="right"
                open={drawerOpen}
                width="80%"
                extra={
                    < Space >
                        {(drawerFrom !== "Shared" && typePage !== "Details" && ((activeKey === "1" && !edit) || (activeKey !== "1" && !edit1))) ?
                            <div className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0} title='Edit'
                                onClick={() => activeKey === "1" ? setEdit(true) : setEdit1(true)}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        if (activeKey === "1") {
                                            setEdit(true)
                                        }
                                        else {
                                            setEdit1(true)
                                        }
                                    }
                                }}
                                aria-label='edit'
                            > <EditIcon height={20} width={20} /></div> : <></>}
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space >
                }
                footer={(uiReady && ((activeKey === "1" && edit) || (activeKey !== "1" && edit1))) ?
                    [<div className="form_action_button">
                        <Button className="gray-button" size="small" onClick={() => PageCancel()} disabled={display}>
                            <FeatherIcon icon="x" />Cancel
                        </Button>
                        {(activeKey === "1" && drawerType === "Update") &&
                            <Button className="red-button" size="small" onClick={() => OnClickofDelete(drawerId)} disabled={display || doubleClick || doubleClick1} loading={doubleClick1}>
                                {!doubleClick1 && <FeatherIcon icon="trash-2" />}Delete
                            </Button>}
                        <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} disabled={display || doubleClick || doubleClick1} loading={doubleClick}>
                            {!doubleClick && <FeatherIcon icon='save' />}{drawerType === "Update" ? "Update" : "Save"}
                        </Button>
                    </div>] : false}
            >{(uiReady && displayData) ?
                <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <Form
                        form={form} // single form for both tabs
                        layout="vertical"
                        onFinish={onSubmit} // send combined data to API
                        onFinishFailed={onFinishFailed}
                    >
                        {(profile.roleName === "Administrator" && drawerType !== "Create") ? (
                            <div style={{ margin: "20px 40px" }}>
                                <Tabs
                                    activeKey={activeKey}
                                    items={[
                                        { key: '1', label: 'Generic Details', children: pageContent1 },
                                        { key: '2', label: 'Product Insights', children: pageContent2 },
                                    ]}
                                    onChange={onChange}
                                    className='Settings-page-tab'
                                />
                            </div>
                        ) : (
                            <>{pageContent1}</>
                        )}
                    </Form>
                </Scrollbars> :
                <div className="spin">
                    <Spin />
                </div>}
            </Drawer >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Product" getCallBack={getRefreshtheTable} />}
            {isModalVisible && <DeleteConnectionPopup confirmPopup={isModalVisible} setConfirmPopup={HandleIsModalVisible} Respone={errorData} page="Details" type="Product" getCallBack={getRefreshtheTable} />}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} GetCallback={deleteMenu} deleteId={deleteId} />}
        </>
    );
}
AddNew.propTypes = {
    drawerOpen: PropTypes.bool.isRequired,
    OpenProduct: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    drawerType: PropTypes.string,
    drawerId: PropTypes.number,
    successMessage: PropTypes.func.isRequired,
    typePage: PropTypes.string,
    drawerFrom: PropTypes.string,
};
export default AddNew;
